import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
import AdminNavbar from "../Layout/AdminNavbar";
import API_BASE_URL from "../config";

const LeaveManagement = () => {
    const navigate = useNavigate();


    const [employees, setEmployees] = useState([]);
    const [selectedEmployee, setSelectedEmployee] = useState("");

    const [leaveLogs, setLeaveLogs] = useState([]);
    const [leaveBalance, setLeaveBalance] = useState([]);

    const [leaveType, setLeaveType] = useState("");
    const [leaveDays, setLeaveDays] = useState("");
    const [searchTerm, setSearchTerm] = useState("");

    const [entriesPerPage, setEntriesPerPage] = useState(6);
    const [currentPage, setCurrentPage] = useState(1);

    const [departments, setDepartments] = useState([]);
    const [selectedDepartment, setSelectedDepartment] = useState("");
    const [filteredEmployees, setFilteredEmployees] = useState([]);

    const [showCreditModal, setShowCreditModal] = useState(false);
    const [modalLeaveType, setModalLeaveType] = useState("");
    const [modalLeavesPerMonth, setModalLeavesPerMonth] = useState("");
    const [modalDuration, setModalDuration] = useState("");

    const [availableLeaveTypes, setAvailableLeaveTypes] = useState([]);
    const [leaveSummary, setLeaveSummary] = useState([]);
    const [modalEmployeeId, setModalEmployeeId] = useState("");
    const [creditEmployees, setCreditEmployees] = useState([]);

    const [showAvailModal, setShowAvailModal] = useState(false);

    const [availForm, setAvailForm] = useState({
        leaveType: "",
        startDate: "",
        endDate: "",
        reason: "",
        document: null,
    });


    const [showEncashModal, setShowEncashModal] = useState(false);

    const [encashForm, setEncashForm] = useState({
        leaveType: "",
        days: ""
    });


    const [sortConfig, setSortConfig] = useState({
        key: "",
        direction: "asc",
    });

    const [financialYearFrom, setFinancialYearFrom] = useState("");
    const [financialYearTo, setFinancialYearTo] = useState("");

    const sortedCreditEmployees = [...creditEmployees].sort((a, b) =>
        a.user.name.localeCompare(b.user.name)
    );



    const handleAvailSubmit = async () => {
        try {
            const token = sessionStorage.getItem("token");

            if (
                !modalEmployeeId ||
                !availForm.leaveType ||
                !availForm.startDate ||
                !availForm.endDate ||
                !availForm.reason
            ) {
                toast.error("Please fill all required fields");
                return;
            }

            const formData = new FormData();
            formData.append("employeeId", modalEmployeeId);
            formData.append("leaveType", availForm.leaveType);
            formData.append("startDate", availForm.startDate);
            formData.append("endDate", availForm.endDate);
            formData.append("reason", availForm.reason);

            if (availForm.document) {
                formData.append("document", availForm.document);
            }

            await fetch(`${API_BASE_URL}/api/leaves/admin/create`, {

                method: "POST",
                headers: {
                    Authorization: `Bearer ${token}`,
                },
                body: formData,
            });

            toast.success("Leave applied successfully");

            setShowAvailModal(false);
            setAvailForm({
                leaveType: "",
                startDate: "",
                endDate: "",
                reason: "",
                document: null,
            });

            fetchLogs();
            fetchLeaveSummary(selectedEmployee);

        } catch (error) {
            console.error(error);
            toast.error("Failed to apply leave");
        }
    };


    const getStartOfMonth = (value) => {
        if (!value) return "";

        const [month, year] = value.trim().split(" ");

        const monthIndex = new Date(`${month} 1, ${year}`).getMonth();
        if (isNaN(monthIndex)) return "";

        return `01/${String(monthIndex + 1).padStart(2, "0")}/${year}`;
    };

    const getEndOfMonth = (value) => {
        if (!value) return "";

        const [month, year] = value.trim().split(" ");

        const monthIndex = new Date(`${month} 1, ${year}`).getMonth();
        if (isNaN(monthIndex)) return "";

        // ✅ last day of the month
        const lastDay = new Date(year, monthIndex + 1, 0).getDate();

        return `${lastDay}/${String(monthIndex + 1).padStart(2, "0")}/${year}`;
    };


    const parseDDMMYYYY = (dateStr) => {
        if (!dateStr) return null;
        const [dd, mm, yyyy] = dateStr.split("/");
        return new Date(`${yyyy}-${mm}-${dd}`);
    };


    useEffect(() => {
        const token = sessionStorage.getItem("token");
        const roles = JSON.parse(sessionStorage.getItem("roles") || "[]");

        if (!token) {
            toast.error("You must be logged in to access this page.");
            navigate("/");
            return;
        }

        // ✅ check admin role
        if (!roles.includes("ROLE_ADMIN")) {
            toast.error("You are not authorized to access this page.");
            navigate("/");
            return;
        }
    }, [navigate]);



    // useEffect(() => {
    //     const token = sessionStorage.getItem("token");
    //     fetch(`${API_BASE_URL}/api/users`, {
    //         headers: { Authorization: "Bearer " + token },
    //     })
    //         .then(res => res.json())
    //         .then(data => {
    //             setEmployees(data.filter(u => u.status === "Active"));
    //         })
    //         .catch(err => console.error(err));
    // }, []);

    useEffect(() => {
        const token = sessionStorage.getItem("token");

        fetch(`${API_BASE_URL}/api/company-info`, {
            headers: { Authorization: "Bearer " + token },
        })
            .then(res => res.json())
            .then(data => {


                // API returns array → take first record
                const company = Array.isArray(data) ? data[0] : data;

                if (!company?.financialYear) {
                    console.warn("No financialYear found");
                    return;
                }

                const parts = splitFinancialYear(company.financialYear);

                if (parts.length !== 2) {
                    console.warn("Invalid financialYear format:", company.financialYear);
                    return;
                }

                const [from, to] = parts;

                setFinancialYearFrom(getStartOfMonth(from));
                setFinancialYearTo(getEndOfMonth(to));
            })

            .catch(err => console.error("Error fetching company info:", err));
    }, []);



    useEffect(() => {
        const token = sessionStorage.getItem("token");

        fetch(`${API_BASE_URL}/api/employees/active`, {
            headers: { Authorization: "Bearer " + token },
        })
            .then(res => res.json())
            .then(data => {
                setEmployees(data);
                setCreditEmployees(data); //  independent list

                const uniqueDepartments = [
                    ...new Set(data.map(emp => emp.department).filter(Boolean))
                ];
                setDepartments(uniqueDepartments);

                setFilteredEmployees(data); // page filters only
            })
            .catch(err => console.error(err));
    }, []);


    useEffect(() => {
        if (!selectedDepartment) {
            // nothing selected → show no employees
            setFilteredEmployees([]);
            setSelectedEmployee("");
            return;
        }

        if (selectedDepartment === "ALL") {
            setFilteredEmployees(employees);
        } else {
            setFilteredEmployees(
                employees.filter(emp => emp.department === selectedDepartment)
            );
        }

        // reset employee when department changes
        setSelectedEmployee("");
    }, [selectedDepartment, employees]);



    const fetchLogs = () => {
        const token = sessionStorage.getItem("token");

        fetch(`${API_BASE_URL}/api/admin/leave-credits`, {
            headers: { Authorization: "Bearer " + token },
        })
            .then(res => res.json())
            .then(data => setLeaveLogs(data))
            .catch(err => console.error("Error fetching logs:", err));
    };


    useEffect(() => {
        fetchLogs();
    }, []);



    const handleCredit = () => {
        if (
            !modalEmployeeId ||
            !modalLeaveType ||
            !modalLeavesPerMonth ||
            !modalDuration
        ) {
            toast.error("Please select employee and fill all fields");
            return;
        }

        const token = sessionStorage.getItem("token");

        fetch(`${API_BASE_URL}/api/admin/assign-leaves`, {
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                Authorization: "Bearer " + token,
            },
            body: JSON.stringify({
                employeeIds: [Number(modalEmployeeId)],
                leaveType: modalLeaveType,
                leavesPerMonth: parseFloat(modalLeavesPerMonth),
                durationMonths: parseInt(modalDuration),
            }),
        })
            .then(res => {
                if (res.ok) {
                    toast.success("Leave credited successfully");
                    setShowCreditModal(false);

                    setModalLeaveType("");
                    setModalLeavesPerMonth("");
                    setModalDuration("");

                    fetchLogs(); // better than reload
                } else {
                    toast.error("Failed to credit leave");
                }
            })
            .catch(() => toast.error("Something went wrong"));
    };


    const confirmDelete = (log, onConfirm) => {
        toast(
            ({ closeToast }) => (
                <div style={{ minWidth: "260px" }}>
                    <p className="fw-semibold mb-2 text-danger">
                        Confirm Delete
                    </p>

                    <div className="mb-2 small">
                        <div><strong>Employee:</strong> {log.employeeName}</div>
                        <div><strong>Leave Type:</strong> {log.leaveType}</div>
                        <div><strong>Date:</strong> {new Date(log.creditedDate).toLocaleDateString()}</div>
                        <div><strong>Days:</strong> {log.creditDays}</div>
                    </div>

                    <p className="mb-2 text-muted small">
                        Are you sure you want to delete this leave entry?
                    </p>

                    <div className="d-flex justify-content-end gap-2 mt-2">
                        <button
                            className="btn btn-sm btn-outline-secondary"
                            onClick={closeToast}
                        >
                            Cancel
                        </button>

                        <button
                            className="btn btn-sm btn-danger"
                            onClick={() => {
                                closeToast();
                                onConfirm();
                            }}
                        >
                            Delete
                        </button>
                    </div>
                </div>
            ),
            {
                autoClose: false,
                closeOnClick: false,
            }
        );
    };



    const handleDelete = (log) => {
        confirmDelete(log, () => {
            const token = sessionStorage.getItem("token");

            fetch(`${API_BASE_URL}/api/admin/leave-credits/${log.id}`, {
                method: "DELETE",
                headers: { Authorization: "Bearer " + token },
            })
                .then((res) => {
                    if (res.ok) {
                        toast.success("Leave log deleted successfully");
                        fetchLogs();
                    } else {
                        toast.error("Failed to delete leave log");
                    }
                })
                .catch(() => toast.error("Error deleting leave log"));
        });
    };




    useEffect(() => {
        const token = sessionStorage.getItem("token");

        fetch(`${API_BASE_URL}/api/leave-types/all`, {
            headers: { Authorization: "Bearer " + token },
        })
            .then(res => res.json())
            .then(data => setAvailableLeaveTypes(data))
            .catch(err => console.error("Failed to fetch leave types:", err));
    }, []);



    useEffect(() => {
        fetchLeaveSummary(selectedEmployee);
    }, [selectedEmployee]);



    const selectedEmployeeName =
        selectedEmployee === "ALL"
            ? null
            : employees.find(emp => emp.id === Number(selectedEmployee))?.user?.name;


    const fyStartDate = parseDDMMYYYY(financialYearFrom);
    const fyEndDate = parseDDMMYYYY(financialYearTo);



    const searchedLogs = (() => {
        // no employee selected → show nothing
        if (!selectedEmployee) return [];

        // ALL selected → show all
        if (selectedEmployee === "ALL") return leaveLogs;

        // specific employee selected
        const emp = employees.find(
            e => e.id === Number(selectedEmployee)
        );

        if (!emp) return [];

        return leaveLogs.filter(
            l => l.employeeName === emp.user.name
        );
    })();


    const filteredLogs = searchedLogs
        .filter(log => {
            // If FY not loaded yet → allow nothing
            if (!fyStartDate || !fyEndDate) return false;

            const leaveDate = new Date(log.creditedDate);

            return leaveDate >= fyStartDate && leaveDate <= fyEndDate;
        })
        .filter(log =>
            log.leaveType?.toLowerCase().includes(searchTerm.toLowerCase()) ||
            log.creditDays?.toString().includes(searchTerm)
        );



    const fetchLeaveSummary = (userId) => {
        if (!userId || userId === "ALL") {
            setLeaveSummary([]);
            return;
        }

        const token = sessionStorage.getItem("token");

        fetch(`${API_BASE_URL}/api/admin/leave-summary/${userId}`, {
            headers: { Authorization: "Bearer " + token },
        })
            .then((res) => res.json())
            .then((data) => {
                // show only leaves with remaining > 0
                const filtered = data.filter(item => Number(item.remaining) > 0);
                setLeaveSummary(filtered);
            })
            .catch((err) => console.error("Error fetching leave summary:", err));
    };


    const indexOfLast = currentPage * entriesPerPage;
    const indexOfFirst = indexOfLast - entriesPerPage;

    const sortedLogs = [...filteredLogs].sort((a, b) => {
        if (!sortConfig.key) return 0;

        let aVal = a[sortConfig.key];
        let bVal = b[sortConfig.key];

        // date handling
        if (sortConfig.key === "creditedDate") {
            aVal = new Date(aVal);
            bVal = new Date(bVal);
        }

        // string handling
        if (typeof aVal === "string") {
            aVal = aVal.toLowerCase();
            bVal = bVal.toLowerCase();
        }

        if (aVal < bVal) return sortConfig.direction === "asc" ? -1 : 1;
        if (aVal > bVal) return sortConfig.direction === "asc" ? 1 : -1;
        return 0;
    });

    const paginatedLogs = sortedLogs.slice(indexOfFirst, indexOfLast);


    const totalPages = Math.ceil(filteredLogs.length / entriesPerPage);



    const handleSort = (key) => {
        setSortConfig(prev => {
            if (prev.key === key) {
                // toggle direction
                return {
                    key,
                    direction: prev.direction === "asc" ? "desc" : "asc",
                };
            }
            // new column sort
            return { key, direction: "asc" };
        });
    };



    const splitFinancialYear = (fy) => {
        return fy.split(/\s*[–-]\s*/); // works for –, —
    };



    return (
        <>
            <div className="fixed-top">
                <AdminNavbar />
            </div>

            <div
                className="container-fluid bg-light"
                style={{ paddingTop: "130px", minHeight: "100vh" }}
            >
                <h4 className="fw-bold mb-3">Leave Management</h4>

                {/* FILTER SECTION  */}
                <div className="card shadow-sm mb-3">
                    <div className="card-body">
                        <div className="row g-3">
                            <div className="col-md-2">
                                <label className="form-label">Select Department</label>
                                <select
                                    className="form-select"
                                    value={selectedDepartment}
                                    onChange={e => setSelectedDepartment(e.target.value)}
                                >
                                    <option value="" disabled>
                                        Select Department
                                    </option>

                                    <option value="ALL">ALL</option>

                                    {departments.map(dep => (
                                        <option key={dep} value={dep}>
                                            {dep}
                                        </option>
                                    ))}
                                </select>


                            </div>

                            <div className="col-md-2">
                                <label className="form-label">Select Employee</label>

                                <select
                                    className="form-select"
                                    value={selectedEmployee}
                                    onChange={e => setSelectedEmployee(e.target.value)}
                                    disabled={!selectedDepartment}
                                >
                                    <option value="" disabled>
                                        {selectedDepartment ? "Select Employee" : "Select Department First"}
                                    </option>

                                    {/* <option value="ALL">ALL</option> */}

                                    {filteredEmployees.map(emp => (
                                        <option key={emp.id} value={String(emp.id)}>
                                            {emp.user.name}
                                        </option>
                                    ))}
                                </select>
                            </div>


                            <div className="col-md-2">
                                <label className="form-label">Financial Year From</label>
                                <input
                                    className="form-control"
                                    value={financialYearFrom}
                                    disabled
                                />
                            </div>

                            <div className="col-md-2">
                                <label className="form-label">To Year</label>
                                <input
                                    className="form-control"
                                    value={financialYearTo}
                                    disabled
                                />
                            </div>

                        </div>
                    </div>
                </div>

                {/*  SEARCH & ENTRIES */}
                <div className="d-flex align-items-center justify-content-start gap-4 mb-2 px-1">

                    {/* ENTRIES */}
                    <div className="d-flex align-items-center gap-2">
                        <span>Show</span>
                        <select
                            className="form-select form-select-sm w-auto"
                            value={entriesPerPage}
                            onChange={e => {
                                setEntriesPerPage(Number(e.target.value));
                                setCurrentPage(1);
                            }}
                        >
                            <option value={5}>5</option>
                            <option value={7}>7</option>
                            <option value={10}>10</option>
                            <option value={20}>20</option>
                        </select>
                        {/* <span>entries</span> */}
                    </div>

                    {/* SEARCH */}
                    <div className="d-flex align-items-center gap-2">
                        {/* <span>Search:</span> */}
                        <input
                            type="text"
                            className="form-control form-control-sm"
                            style={{ width: "220px" }}
                            placeholder="Search..."
                            value={searchTerm}
                            onChange={e => {
                                setSearchTerm(e.target.value);
                                setCurrentPage(1);
                            }}
                        />
                    </div>

                </div>



                {/* TABLES  */}
                <div className="row">
                    {/* LEFT TABLE */}
                    <div className="col-md-9">
                        <div className="card shadow-sm-none">
                            <div className="card-body p-0">
                                <table className="table table-bordered-none mb-0">
                                    <thead className="table-secondary">
                                        <tr>
                                            <th
                                                style={{ cursor: "pointer" }}
                                                onClick={() => handleSort("leaveType")}
                                            >
                                                Leave Type {sortConfig.key === "leaveType" && (sortConfig.direction === "asc" ? "↑" : "↓")}
                                            </th>

                                            <th>Leave Code</th>

                                            <th
                                                style={{ cursor: "pointer" }}
                                                onClick={() => handleSort("creditedDate")}
                                            >
                                                Credited Date {sortConfig.key === "creditedDate" && (sortConfig.direction === "asc" ? "↑" : "↓")}
                                            </th>

                                            <th
                                                style={{ cursor: "pointer" }}
                                                onClick={() => handleSort("creditDays")}
                                            >
                                                Days {sortConfig.key === "creditDays" && (sortConfig.direction === "asc" ? "↑" : "↓")}
                                            </th>

                                            <th>Day State</th>
                                            <th>Action</th>
                                        </tr>
                                    </thead>

                                    <tbody>
                                        {filteredLogs.length > 0 ? (
                                            paginatedLogs.map(log => (
                                                <tr key={log.id}>
                                                    <td>{log.leaveType}</td>
                                                    <td>{log.leaveType?.substring(0, 2).toUpperCase()}</td>
                                                    <td>{new Date(log.creditedDate).toLocaleDateString()}</td>
                                                    <td>{log.creditDays}</td>
                                                    <td>Credited</td>
                                                    <td>
                                                        <button
                                                            className="btn btn-sm btn-danger"
                                                            onClick={() => handleDelete(log)}
                                                        >
                                                            Delete
                                                        </button>


                                                    </td>
                                                </tr>
                                            ))
                                        ) : (
                                            <tr>
                                                <td colSpan="6" className="text-center text-muted py-4">
                                                    No data available in table
                                                </td>
                                            </tr>
                                        )}
                                    </tbody>
                                </table>
                            </div>
                        </div>
                    </div>

                    {/* RIGHT BALANCE TABLE */}
                    <div className="col-md-3">
                        <div className="card shadow-sm-none">
                            <div className="card-body p-0">
                                <table className="table table-bordered-none mb-0">
                                    <thead className="table-secondary">
                                        <tr>
                                            <th>Leave Type</th>
                                            <th>Balance</th>
                                        </tr>
                                    </thead>

                                    <tbody>
                                        {leaveSummary.length > 0 ? (
                                            leaveSummary.map((item, index) => (
                                                <tr key={index}>
                                                    <td>{item.leaveType}</td>
                                                    <td>{item.remaining}</td>
                                                </tr>
                                            ))
                                        ) : (
                                            <tr>
                                                <td colSpan="2" className="text-center text-muted py-3">
                                                    No remaining leave balance
                                                </td>

                                            </tr>
                                        )}
                                    </tbody>
                                </table>
                            </div>
                        </div>
                    </div>



                </div>

                {/* PAGINATION */}
                {totalPages > 1 && (
                    <nav className="d-flex justify-content-center mt-3">
                        <ul className="pagination pagination-sm">
                            <li className={`page-item ${currentPage === 1 ? "disabled" : ""}`}>
                                <button
                                    className="page-link"
                                    onClick={() => setCurrentPage(currentPage - 1)}
                                >
                                    Previous
                                </button>
                            </li>

                            {Array.from({ length: totalPages }, (_, i) => (
                                <li
                                    key={i}
                                    className={`page-item ${currentPage === i + 1 ? "active" : ""}`}
                                >
                                    <button
                                        className="page-link"
                                        onClick={() => setCurrentPage(i + 1)}
                                    >
                                        {i + 1}
                                    </button>
                                </li>
                            ))}

                            <li className={`page-item ${currentPage === totalPages ? "disabled" : ""}`}>
                                <button
                                    className="page-link"
                                    onClick={() => setCurrentPage(currentPage + 1)}
                                >
                                    Next
                                </button>
                            </li>
                        </ul>
                    </nav>
                )}


                {/*  DIVIDER*/}
                <hr className="my-4" />

                {/* ACTION SECTION */}
                <div className="card shadow-sm">
                    <div className="card-body">
                        <div className="d-flex justify-content-end align-items-center gap-3 flex-wrap">

                            <button
                                className="btn btn-primary"
                                onClick={() => {
                                    setModalEmployeeId(selectedEmployee || "");
                                    setShowCreditModal(true);
                                }}
                            >
                                ➕ Credit
                            </button>



                            <button
                                className="btn btn-info text-white"
                                onClick={() => {
                                    setModalEmployeeId(selectedEmployee || "");
                                    setShowAvailModal(true);
                                }}
                            >
                                ➖ Avail
                            </button>



                            <button
                                className="btn btn-success"
                                onClick={() => {
                                    setModalEmployeeId(selectedEmployee || "");
                                    setEncashForm({ leaveType: "", days: "" });
                                    setShowEncashModal(true);
                                }}
                            >
                                💰 Encash
                            </button>


                            <button className="btn btn-danger" onClick={() => navigate(-1)}>
                                ⏻ Exit
                            </button>

                        </div>
                    </div>
                </div>

                {/*CREDIT MODAL*/}
                {showCreditModal && (
                    <>
                        {/* Backdrop */}
                        <div className="modal-backdrop fade show"></div>

                        <div className="modal fade show d-block" tabIndex="-1">
                            <div className="modal-dialog modal-md modal-dialog-centered" style={{ maxWidth: "35%" }}>
                                <div className="modal-content">

                                    {/* Header */}
                                    <div className="modal-header">
                                        <h5 className="modal-title">Credit Leave</h5>
                                        <button
                                            type="button"
                                            className="btn-close"
                                            onClick={() => setShowCreditModal(false)}
                                        ></button>
                                    </div>

                                    {/* Body */}
                                    <div className="modal-body">
                                        <div className="row">
                                            <div className="col-md-6 mb-3">
                                                <label className="form-label">Select Employee</label>

                                                <select
                                                    className="form-select"
                                                    value={modalEmployeeId}
                                                    disabled={!!selectedEmployee}
                                                    onChange={(e) => setModalEmployeeId(e.target.value)}
                                                    style={{
                                                        maxHeight: "200px",
                                                        overflowY: "auto"
                                                    }}
                                                >
                                                    <option value="" disabled>
                                                        Select Employee
                                                    </option>

                                                    {sortedCreditEmployees.map(emp => (
                                                        <option key={emp.id} value={emp.id}>
                                                            {emp.user.name}
                                                        </option>
                                                    ))}
                                                </select>
                                            </div>

                                            <div className="col-md-6 mb-3">
                                                <label className="form-label">Leave Type / Code</label>
                                                <select
                                                    className="form-select"
                                                    value={modalLeaveType}
                                                    onChange={e => setModalLeaveType(e.target.value)}
                                                >
                                                    <option value="">Select Leave Type</option>

                                                    {availableLeaveTypes.length > 0 ? (
                                                        availableLeaveTypes.map(type => (
                                                            <option key={type.id} value={type.name}>
                                                                {type.name}
                                                            </option>
                                                        ))
                                                    ) : (
                                                        <option disabled>Loading...</option>
                                                    )}
                                                </select>
                                            </div>
                                        </div>

                                        <div className="row">
                                            <div className="col-md-6 mb-3">
                                                <label className="form-label">Leaves Per Month</label>
                                                <input
                                                    type="number"
                                                    step="0.5"
                                                    className="form-control"
                                                    value={modalLeavesPerMonth}
                                                    onChange={e => setModalLeavesPerMonth(e.target.value)}
                                                />
                                            </div>

                                            <div className="col-md-6 mb-3">
                                                <label className="form-label">Duration (Months)</label>
                                                <input
                                                    type="number"
                                                    className="form-control"
                                                    value={modalDuration}
                                                    onChange={e => setModalDuration(e.target.value)}
                                                />
                                            </div>
                                        </div>
                                    </div>

                                    {/* Footer */}
                                    <div className="modal-footer">
                                        <button
                                            className="btn btn-secondary"
                                            onClick={() => setShowCreditModal(false)}
                                        >
                                            Cancel
                                        </button>

                                        <button
                                            className="btn btn-primary"
                                            onClick={handleCredit}
                                        >
                                            Save
                                        </button>
                                    </div>

                                </div>
                            </div>
                        </div>
                    </>
                )}

                {showAvailModal && (
                    <>
                        <div className="modal-backdrop fade show"></div>

                        <div className="modal fade show d-block" tabIndex="-1">
                            <div className="modal-dialog modal-md modal-dialog-centered" style={{ maxWidth: "55%" }}>
                                <div className="modal-content">

                                    {/* Header */}
                                    <div className="modal-header">
                                        <h5 className="modal-title">Avail Leave</h5>
                                        <button
                                            type="button"
                                            className="btn-close"
                                            onClick={() => setShowAvailModal(false)}
                                        />
                                    </div>

                                    {/* Body */}
                                    <div className="modal-body">
                                        <div className="row">
                                            {/* Employee */}
                                            <div className="col-md-6 mb-3">
                                                <label className="form-label">Employee</label>
                                                <select
                                                    className="form-select"
                                                    value={modalEmployeeId}
                                                    disabled={!!selectedEmployee}
                                                    onChange={e => setModalEmployeeId(e.target.value)}
                                                >
                                                    <option value="">Select Employee</option>
                                                    {sortedCreditEmployees.map(emp => (
                                                        <option key={emp.id} value={emp.id}>
                                                            {emp.user.name}
                                                        </option>
                                                    ))}
                                                </select>
                                            </div>

                                            {/* Leave Type */}
                                            <div className="col-md-6 mb-3">
                                                <label className="form-label">Leave Type</label>
                                                <select
                                                    className="form-select"
                                                    value={availForm.leaveType}
                                                    onChange={e =>
                                                        setAvailForm({ ...availForm, leaveType: e.target.value })
                                                    }
                                                >
                                                    <option value="">Select Leave Type</option>
                                                    {availableLeaveTypes.map(type => (
                                                        <option key={type.id} value={type.name}>
                                                            {type.name}
                                                        </option>
                                                    ))}
                                                </select>
                                            </div>
                                        </div>

                                        {/* Dates */}
                                        <div className="row">
                                            <div className="col-md-6 mb-3">
                                                <label className="form-label">Start Date</label>
                                                <input
                                                    type="date"
                                                    className="form-control"
                                                    value={availForm.startDate}
                                                    onChange={e =>
                                                        setAvailForm({ ...availForm, startDate: e.target.value })
                                                    }
                                                />
                                            </div>

                                            <div className="col-md-6 mb-3">
                                                <label className="form-label">End Date</label>
                                                <input
                                                    type="date"
                                                    className="form-control"
                                                    value={availForm.endDate}
                                                    onChange={e =>
                                                        setAvailForm({ ...availForm, endDate: e.target.value })
                                                    }
                                                />
                                            </div>
                                        </div>

                                        {/* Reason */}
                                        <div className="mb-3">
                                            <label className="form-label">Reason</label>
                                            <textarea
                                                className="form-control"
                                                rows="3"
                                                value={availForm.reason}
                                                onChange={e =>
                                                    setAvailForm({ ...availForm, reason: e.target.value })
                                                }
                                            />
                                        </div>

                                        {/* Document */}
                                        <div className="mb-3">
                                            <label className="form-label">Supporting Document (optional)</label>
                                            <input
                                                type="file"
                                                className="form-control"
                                                onChange={e =>
                                                    setAvailForm({ ...availForm, document: e.target.files[0] })
                                                }
                                            />
                                        </div>
                                    </div>

                                    {/* Footer */}
                                    <div className="modal-footer">
                                        <button
                                            className="btn btn-secondary"
                                            onClick={() => setShowAvailModal(false)}
                                        >
                                            Cancel
                                        </button>

                                        <button
                                            className="btn btn-info text-white"
                                            onClick={handleAvailSubmit}
                                        >
                                            Save
                                        </button>
                                    </div>

                                </div>
                            </div>
                        </div>
                    </>
                )}

                {showEncashModal && (
                    <>
                        <div className="modal-backdrop fade show"></div>

                        <div className="modal fade show d-block" tabIndex="-1">
                            <div
                                className="modal-dialog modal-md modal-dialog-centered"
                                style={{ maxWidth: "45%" }}
                            >
                                <div className="modal-content">

                                    {/* Header */}
                                    <div className="modal-header">
                                        <h5 className="modal-title">Encash Leave</h5>
                                        <button
                                            type="button"
                                            className="btn-close"
                                            onClick={() => setShowEncashModal(false)}
                                        />
                                    </div>

                                    {/* Body */}
                                    <div className="modal-body">
                                        <div className="row">

                                            {/* Employee */}
                                            <div className="col-md-6 mb-3">
                                                <label className="form-label">Employee</label>
                                                <select
                                                    className="form-select"
                                                    value={modalEmployeeId}
                                                    disabled={!!selectedEmployee}
                                                    onChange={e => setModalEmployeeId(e.target.value)}
                                                >
                                                    <option value="">Select Employee</option>
                                                    {sortedCreditEmployees.map(emp => (
                                                        <option key={emp.id} value={emp.id}>
                                                            {emp.user.name}
                                                        </option>
                                                    ))}
                                                </select>
                                            </div>

                                            {/* Leave Type */}
                                            <div className="col-md-6 mb-3">
                                                <label className="form-label">Leave Type</label>
                                                <select
                                                    className="form-select"
                                                    value={encashForm.leaveType}
                                                    onChange={e =>
                                                        setEncashForm({
                                                            ...encashForm,
                                                            leaveType: e.target.value
                                                        })
                                                    }
                                                >
                                                    <option value="">Select Leave Type</option>
                                                    {availableLeaveTypes.map(type => (
                                                        <option key={type.id} value={type.name}>
                                                            {type.name}
                                                        </option>
                                                    ))}
                                                </select>
                                            </div>

                                        </div>

                                        {/* Encash Days */}
                                        <div className="mb-3">
                                            <label className="form-label">Encash Days</label>
                                            <input
                                                type="number"
                                                min="0.5"
                                                step="0.5"
                                                className="form-control"
                                                value={encashForm.days}
                                                onChange={e =>
                                                    setEncashForm({
                                                        ...encashForm,
                                                        days: e.target.value
                                                    })
                                                }
                                                placeholder="Enter number of days"
                                            />
                                        </div>
                                    </div>

                                    {/* Footer */}
                                    <div className="modal-footer">
                                        <button
                                            className="btn btn-secondary"
                                            onClick={() => setShowEncashModal(false)}
                                        >
                                            Cancel
                                        </button>

                                        <button
                                            className="btn btn-success"
                                            onClick={() => {
                                                // we can add api here
                                                console.log("Encash Data", {
                                                    employeeId: modalEmployeeId,
                                                    ...encashForm
                                                });
                                            }}
                                        >
                                            Save
                                        </button>
                                    </div>

                                </div>
                            </div>
                        </div>
                    </>
                )}



            </div>
        </>
    );
};

export default LeaveManagement;
